import { getGaCustomDimensions } from '../dimensions';

export { getGaCustomDimensions };
